/* global FB, ga */
/* eslint-env browser */
'use strict';
import './_modules/outdated/scripts'; // Has to be first
import 'hapi-browser-log/lib/browser/script.js';
import scrollTriggers from 'scroll-triggers';
import 'smooth-scroller';
import 'social-share-button';
import '@firstandthird/bounce';
import '@firstandthird/mailchimp-signup';
import '@firstandthird/svg-injector';
import 'scrollup-header';
import './_modules/header/scripts';
import './_modules/announcement-bar/scripts';
import './_modules/updates-modal/scripts';
import './_modules/utils/toggle-class';
import './_modules/heros/scripts';
import './_modules/utils/toggle-visibility';
import './_modules/filters/scripts';
import './_modules/cards/scripts';
import './_modules/flyout/scripts';
import './_modules/onboarding/scripts';
import './_modules/footer/newsletter.js';
import isTouch from './_modules/feature-detect/touch';
import { addClass, fire, on, findOne, ready } from 'domassist';
import gaTrack from 'ga-track';
import './_modules/pdat/scripts';

window.gaTrack = gaTrack;
// GTag is used for adwords tracking so both GA and GTag are present
gaTrack.force = 'ga';
window.scrollTriggers = scrollTriggers;
window.onload = () => {
  const bounceModal = findOne('#bounce-modal');

  fire(window, 'resize', {
    detail: {
      force: true
    }
  });

  if (typeof window.FB !== 'undefined') {
    FB.Event.subscribe('edge.create', (url, element) => {
      if (typeof window.ga === 'undefined') {
        return;
      }
      ga('send', 'social', 'facebook', 'like', url);

      if (element && bounceModal.contains && bounceModal.contains(element)) {
        gaTrack.sendEvent('bounce-modal', 'like', 'click');
      }
    });
  }

  gaTrack.track(
    [
      {
        element: 'button.nav-toggler',
        category: 'site-header',
        action: 'mobile-nav'
      },
      {
        element: '.Support-body a',
        category: 'crisis'
      }
    ]
  );
};

on(document.documentElement, 'bounce:show', () => {
  gaTrack.sendEvent('bounce-modal', 'show');
});

on(document.documentElement, 'bounce:hide', () => {
  gaTrack.sendEvent('bounce-modal', 'hide');
});

ready(() => {
  window.hapiLogger.logEndpoint = '/browser-log';
});

if (isTouch()) {
  addClass(document.documentElement, 'touch');
} else {
  addClass(document.documentElement, 'no-touch');
}
